module.exports = __webpack_public_path__ + "45a8efe15cb70c6e8894f15bd885b81b.pdf";